import { render } from "./Imprint.vue?vue&type=template&id=1dcb3774&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=1dcb3774&scoped=true&lang=css"

import exportComponent from "C:\\Users\\raubart\\Documents\\GitLab\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcb3774"]])

export default __exports__